module.exports = __webpack_public_path__ + "static/img/1_10_1.a1f690c2.jpg";